//Note: Enovia builds contain word "build" in the type. MSAP Builds are either type 'Z' or 'Y'
export const isBuildType: (type: string) => boolean = (type) =>
  type?.toLowerCase().indexOf("build") > -1 ||
  type?.toLowerCase() === "z" ||
  type?.toLowerCase() === "y";
